const sliderModule = {
  namespaced: true,
  state     : {
    isPaused     : false,
    currentNumber: 0,
    debug        : true,
  },
  getters   : {
    isPaused (state) {
      return state.isPaused;
    },

  },
  mutations : {
    togglePlay (state, val) {
      // console.log(val);
      if (val === true || val === false) {
        state.isPaused = val;
      } else {
        state.isPaused = !state.isPaused;
      }
      // console.log('togglePlay');
    },

  }
};

export default sliderModule;
